import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { withStore } from 'store';
import { setShoppingCartPrices } from 'store/actions/externalGiftTable';
import TableHero from 'components/gifts-table/TableHero';
import TableHeroMobile from 'components/gifts-table/TableHeroMobile';
import { getShoppingCartPrices } from 'util/prices';
import { Back } from 'components';
import { useWindowSize } from 'hooks';
import { propTypes } from 'react-barcode';


function PaymentFlowLayout({
  children,
  dispatch,
  tableInfo,
  shoppingCartProducts = [],
  ...props
}) {
  const [, { isMobile }] = useWindowSize();
  useEffect(() => {
    const shoppingCartPrices = getShoppingCartPrices(shoppingCartProducts);
    dispatch(setShoppingCartPrices(shoppingCartPrices));
  }, [shoppingCartProducts]);

  return (
    <>
    {isMobile && <Back title={props.titleBack?props.titleBack:''}/>}
    <section className={!isMobile?'mb-5':'mb-5 border-top'}>
      {!isMobile?(
        <TableHero
          image={tableInfo?.image}
          typeId={tableInfo?.type?.id}
          eventName={tableInfo?.type?.name}
          name={tableInfo?.name}
          date={tableInfo?.date}
          readOnly
        />
      ):(
        <TableHeroMobile
          image={tableInfo?.image}
          typeId={tableInfo?.type?.id}
          eventName={tableInfo?.type?.name}
          name={tableInfo?.name}
          date={tableInfo?.date}
          readOnly
        />
      )}
      
      <Container>{children}</Container>
    </section>
    </>
  );
}

export default withStore({
  mapStateToProps: (state) => ({
    tableInfo: state.externalGiftTable.giftTableInfo.data,
    shoppingCartProducts: state.externalGiftTable.shoppingCartProducts.data,
  }),
})(PaymentFlowLayout);
